// events: {
//   [eventName]: {
//     [scope]: handlers<Function[]>
//   }
// }

// Một sự kiện có thể phát đến nhiều phạm vi khác nhau, mỗi thành phần lắng nghe sẽ lắng nghe tại một phạm vi nhất định

class SharedStateBus {
  events: any;
  constructor() {
    this.events = {}; // Toàn bộ các sự kiện đang được lắng nghe: { scope, handlers }
  }

  /**
   * Lắng nghe một sự kiện đến từ đối tượng window.
   *
   * @param {string} eventName - Tên sự kiện muốn lắng nghe.
   * @param {string} scope - Phạm vi sự kiện ảnh hưởng (toàn cục, component cụ thể, ...)
   * @param {...Function} handler - Định nghĩa hàm xử lý khi sự kiện được phát đến.
   */
  on(eventName: string, scope: string, handler: any) {
    if (!this.events[eventName]) {
      this.events[eventName] = {
        mainHandler: (event: any) => {
          const { scope: influenceRange, payload } = event.detail;
          console.log(
            `[SHARED-STATE]: RECEIVED --> [eventName]|[scope]: [${eventName}]|[${influenceRange}]`
          );
          this.events[eventName][influenceRange].forEach((cb: any) => cb(payload));
        },
      };
    }

    if (!this.events[eventName][scope]) {
      this.events[eventName][scope] = [handler];

      window.addEventListener(eventName, this.events[eventName].mainHandler);

      console.log(`[SHARED-STATE]: INIT --> [scope]: ${scope}`);
      return;
    }

    this.events[eventName][scope].push(handler);
    console.log(`[SHARED-STATE]: REGISTER --> [eventName]|[scope]: [${eventName}]|[${scope}]`);
  }

  /**
   * Phát một sự kiện đến phạm vi tương ứng qua đối tượng window để đồng bộ dữ liệu cho bên ibond.
   *
   * @param {string} eventName - Tên sự kiện được phát.
   * @param {string} scope - Phạm vi sự kiện ảnh hưởng (toàn cục, component cụ thể, ...)
   * @param {object} payload - Dữ liệu chi tiết kèm theo sự kiện.
   */
  emit(eventName: string, scope: string, payload: any) {
    window.dispatchEvent(new CustomEvent(eventName, { detail: { scope, payload } }));
  }

  /**
   * Ngừng lắng nghe một sự kiện đến từ đối tượng window.
   *
   * @param {string} eventName - Tên sự kiện muốn ngừng lắng nghe.
   * @param {string} scope - Phạm vi sự kiện ảnh hưởng (toàn cục, component cụ thể, ...)
   * @param {...Function} handler - Danh sách các hàm xử lý đã đăng ký lắng nghe cùng sự kiện.
   */
  off(eventName: string, scope: string, handler: any) {
    console.log(`[SHARED-STATE]: OFF --> [eventName]|[scope]: [${eventName}]|[${scope}]`);
    if (
      this.events[eventName] &&
      this.events[eventName][scope] &&
      this.events[eventName][scope].length
    ) {
      this.events[eventName][scope] = this.events[eventName][scope].filter(
        (cb: any) => cb !== handler
      );

      // Xóa scope không không có handler nào đăng ký
      if (this.events[eventName][scope] && !this.events[eventName][scope].length) {
        delete this.events[eventName][scope];
        console.log(`[SHARED-STATE]: DELETE --> [scope]: [${scope}]`);
      }
    }

    // Sự kiện không còn [scope] nào có handler -> remover event
    if (!Object.keys(this.events[eventName]).length) {
      window.removeEventListener(eventName, this.events[eventName].mainHandler);
      console.log(`[SHARED-STATE]: DELETE --> [eventName]|[scope]: [${eventName}]|[${scope}]`);
    }
  }

  getAllEvents() {
    return this.events;
  }

  getEvent(eventName: string) {
    return this.events[eventName];
  }
}

const SharedStateBusInstance = new SharedStateBus();

export default SharedStateBusInstance;


